/*eslint no-useless-escape: 1 */
export const isFormValid = (form, validators) => {
  return !validators.some((v) => {
    const keys = v.key.split('.');
    return v.validator.some((check) => {
      let value = form;
      keys.forEach((key) => (value = value[key]));
      const { isError } = check(value, form);
      return isError;
    });
  });
};

export const requiredValidator = (value) => {
  const isError = !value || value.trim() === '';

  return {
    isError,
    message: 'Please fill out this field',
  };
};

export const requiredValidatorWithoutMessage = (value) => {
  const isError = !value || value.trim() === '';

  return {
    isError,
  };
};

export const emailValidator = (value) => {
  const reg = /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/;
  const isError = value && value !== '' ? !reg.test(value) : false;

  return {
    isError,
    message: 'Please fill out a valid Email address',
  };
};

export const isFieldContainsInfo = (value, fieldsArr, form) => {
  if (!form) return false;
  return fieldsArr.some((fieldName) => value.toLowerCase().includes(form[fieldName]?.toLowerCase()));
};
export const checkConsecutiveLetters = (lettersArr) => {
  if (lettersArr.length < 3) return undefined;
  return lettersArr.some(
    (val, i, arr) => arr[i + 1]?.toLowerCase() === val.toLowerCase() && arr[i + 2]?.toLowerCase() === val.toLowerCase(),
  );
};

export const getSpecialCharsRegex = () => {
  const hasLowercaseCharRegex = '(?=.*[a-z])';
  const hasUppercaseCharRegex = '(?=.*[A-Z])';
  const hasNumberRegex = '(?=.*[0-9])';
  const hasSpecialCharRegex = '(?=.*[!@#$%^&*{}()=+_\\-~`|:;?><[\\],"\'./\\\\])';
  return `^${hasLowercaseCharRegex}${hasUppercaseCharRegex}${hasNumberRegex}${hasSpecialCharRegex}`;
};

export const passwordValidator = (value, form) => {
  const passwordSpecialCharactersRegex = new RegExp(getSpecialCharsRegex());
  const passwordRequiredLengthCheck = value.length >= 8;
  const passwordAsLettersArray = value.split('');
  const consecutiveLetters = checkConsecutiveLetters(passwordAsLettersArray);
  const passwordContainsOtherFieldValue = isFieldContainsInfo(
    value,
    ['first_name', 'last_name', 'phone', 'email'],
    form,
  );
  const missedRequirement = {
    identicalLettersRequirement: consecutiveLetters,
    specificConstantsRequirement: passwordContainsOtherFieldValue,
    passwordLengthRequirement: !passwordRequiredLengthCheck,
    specialCharactersRequirement: !passwordSpecialCharactersRegex.test(value),
  };
  const isError = Object.values(missedRequirement).some((value) => value);

  return {
    isError,
    missedRequirement,
    message: "Password isn't secure enough. Please follow instructions",
  };
};

export const patternValidator = (pattern, message) => (value) => {
  const isError = value && !pattern.test(value);

  return {
    isError,
    message,
  };
};
